// Copyright (c) 2017 Deere & Company

import * as ClaimSearchHelper from '../../shared/services/claim-search-helper';
import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';

export const onSearch = (searchBy, query) =>
    dispatch => {

        if (ClaimSearchHelper.mapClaimValidation(searchBy, query)) {

            dispatch(routerActions.push(`/claims/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

        } else {

            const translatedErrorMessage = translate(ClaimSearchHelper.mapValidationErrorMessages(searchBy));

            errorAlertBar(createErrorObject(translatedErrorMessage));

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/search.js